module.exports = __webpack_public_path__ + "static/media/icon-crown-01.9f26f1cf.svg";